module.exports = __webpack_public_path__ + "static/media/ShopIcon.28142a7e.png";